import { Component, OnInit } from '@angular/core';
import { LevelLayers } from './levels';
import { LevelSelectionService } from './level-selection.service';
import { Industries } from '../../../../shared/util/industries';
import { DropdownMenuComponent } from '../../../../shared/components/dropdown-menu/dropdown-menu.component';
import { NgIf } from '@angular/common';
import {
  COUNTY_LEVEL_LAYER,
  H3_RES5_LEVEL_LAYER,
  H3_RES7_LEVEL_LAYER,
  STATE_LEVEL_LAYER,
} from '../../services/layer-store.service';

export const LEVEL_SELECTION_DROPDOWN = 'level';

@Component({
  selector: 'app-level-selection',
  templateUrl: './level-selection.component.html',
  styleUrls: ['./level-selection.component.scss'],
  imports: [DropdownMenuComponent, NgIf],
})
export class LevelSelectionComponent implements OnInit {
  public levels!: any;

  public isDropdownActive: boolean = false;

  public isDropdownVisible: boolean = true;

  constructor(private levelService: LevelSelectionService) {
    this.levels = LevelLayers;
  }

  public getHint(levelKey: string): string {
    switch (levelKey) {
      case STATE_LEVEL_LAYER:
        return 'Nationwide overview';
      case COUNTY_LEVEL_LAYER:
        return 'Regional detail';
      case H3_RES5_LEVEL_LAYER:
        return '5-mile cells — local area';
      case H3_RES7_LEVEL_LAYER:
        return '1-mile cells — neighborhood';
      default:
        return 'Switch between states, counties and cells';
    }
  }

  ngOnInit(): void {}

  public changeActiveSelection(event: Industries | LevelLayers): void {
    this.levelService.changeLevelBySelection(event as LevelLayers);
  }

  protected readonly LEVEL_SELECTION_DROPDOWN = LEVEL_SELECTION_DROPDOWN;
}
